import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../Config/Config";

export const fetchSchoolNameData = createAsyncThunk(
  "api/schoolname",
  async () => {
    const response = await fetch(`${FULL_API_BASE_URL}/get-schools-list`);
    const data = await response.json();
    return data;
  }
);

const schoolSlice = createSlice({
  name: "schoolName",
  initialState: {
    schoolnamedata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSchoolNameData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSchoolNameData.fulfilled, (state, action) => {
        state.loading = false;
        state.schoolnamedata = action.payload;
      })
      .addCase(fetchSchoolNameData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default schoolSlice.reducer;
